import { Component, Input, Output,EventEmitter, ViewChild } from '@angular/core';

/**
 * Generated class for the GmoPaymentComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
    selector: 'gmo-payment',
    templateUrl: 'gmo-payment.html'
})
export class GmoPaymentComponent {

    
    @ViewChild('paymentForm') paymentForm: any;
    gmopayment:any;
    @Input() gmolink:any;
    @Input() shopId:any;

    constructor() {
    }

    submit(){
        this.paymentForm.nativeElement.submit();
    }

}



// WEBPACK FOOTER //
// ./src/components/gmo-payment/gmo-payment.ts